import { Disclosure, DisclosurePanel } from '@headlessui/react';
import { MobileNavLink } from './MobileNavLink';
import { CMSLink } from '../CMSLink';
import { GeneralInformation } from '@/payload-types';

type navItemsFromGeneralInformation = NonNullable<
  GeneralInformation['navigationItems']
>;
type navItemFromNavItem = navItemsFromGeneralInformation[number];

export function MobileFlyMenu({
  navigationItems,
  closeMenu,
}: {
  navigationItems: navItemFromNavItem;
  closeMenu?: () => void;
}) {
  return (
    <div>
      <div className="block w-full" onClick={closeMenu}>
        <CMSLink {...navigationItems.link} />
      </div>
      <Disclosure as="div" className="" defaultOpen={true}>
        <DisclosurePanel className="mt-2 space-y-2 ">
          {navigationItems.links &&
            navigationItems.links.map((item) => (
              <MobileNavLink
                key={item.id}
                parent={navigationItems.link}
                href={item}
                closeMenu={closeMenu}
                className="block rounded-lg py-2 pl-6 pr-3 text-left text-lg text-gray-900 hover:bg-gray-50"
              />
            ))}
        </DisclosurePanel>
      </Disclosure>
      <hr className="m-2 border-slate-300/40" />
    </div>
  );
}
